import { Box } from "@mui/material";

export const ForbiddenError = () => {
  return <Box flex={1}></Box>;
};
